import { render, staticRenderFns } from "./template.html?vue&type=template&id=26b81c2f&scoped=true&"
import script from "./ShowForm.vue?vue&type=script&lang=js&"
export * from "./ShowForm.vue?vue&type=script&lang=js&"
import style0 from "./styles.scss?vue&type=style&index=0&id=26b81c2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b81c2f",
  null
  
)

export default component.exports